import { Badge, Box, Grid, Heading, HStack, Tag, Text } from '@chakra-ui/react'
import { FC } from 'react'

import {
  Article,
  categoryColors,
  categoryLabels
} from '@base/variables/help-center/articles'

interface ArticleListProps {
  articles: Article[]
  onSelect: (article: Article) => void
}

const ArticleList: FC<ArticleListProps> = ({ articles, onSelect }) => {
  if (articles.length === 0) {
    return (
      <Box textAlign="center" py={12}>
        <Text fontSize="lg" color="gray.500">
          Nenhum artigo encontrado.
        </Text>
        <Text fontSize="sm" color="gray.400" mt={2}>
          Tente buscar por outro termo ou selecione outra categoria.
        </Text>
      </Box>
    )
  }

  return (
    <Grid templateColumns={['1fr', '1fr', 'repeat(2, 1fr)']} gap={4}>
      {articles.map(article => (
        <Box
          key={article.id}
          p={5}
          bg="white"
          border="1px solid"
          borderColor="gray.100"
          borderRadius="8px"
          cursor="pointer"
          transition="all ease .2s"
          _hover={{
            borderColor: 'green.300',
            boxShadow: 'md',
            transform: 'translateY(-2px)'
          }}
          onClick={() => onSelect(article)}
        >
          <Badge
            colorScheme={categoryColors[article.category]}
            variant="solid"
            borderRadius="full"
            px={2}
            fontSize="xs"
            mb={2}
          >
            {categoryLabels[article.category]}
          </Badge>
          <Heading fontSize="md" fontWeight="700" color="gray.900" mb={2}>
            {article.title}
          </Heading>
          <Text fontSize="sm" color="gray.900" noOfLines={2}>
            {article.summary}
          </Text>
          <HStack mt={3} spacing={1} flexWrap="wrap">
            {article.tags.slice(0, 3).map(tag => (
              <Tag
                key={tag}
                size="sm"
                variant="subtle"
                colorScheme="gray"
                color="gray.900"
              >
                {tag}
              </Tag>
            ))}
          </HStack>
        </Box>
      ))}
    </Grid>
  )
}

export default ArticleList
